import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../utils/api';
import Toast from '../components/Toast';

export default function Profile() {
  const { user, updateUser } = useAuth();
  const [toast, setToast] = useState(null);

  const handleDisable2FA = async () => {
    try {
      await api.post('/auth/disable-2fa', {});
      updateUser({ totpEnabled: false });
      setToast({ message: '2FA desactivado', type: 'success' });
    } catch (err) {
      setToast({ message: err.message, type: 'error' });
    }
  };

  return (
    <div>
      {toast && <Toast {...toast} onClose={() => setToast(null)} />}
      <h2 className="text-xl font-bold text-gray-900 mb-6">Mi perfil</h2>

      <div className="bg-white rounded-xl p-6 shadow-sm mb-4">
        <div className="flex items-center gap-4 mb-5">
          <div className="w-14 h-14 rounded-full flex items-center justify-center text-xl font-bold" style={{ backgroundColor: '#FFB800', color: '#0f1117' }}>
            {user?.name?.charAt(0).toUpperCase()}
          </div>
          <div>
            <p className="font-semibold text-lg">{user?.name}</p>
            <p className="text-sm text-gray-500">{user?.email}</p>
            <span className="inline-block text-xs px-2 py-0.5 rounded mt-1 capitalize" style={{ backgroundColor: '#f1f3f5', color: '#495057' }}>{user?.role}</span>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl p-6 shadow-sm mb-4">
        <h3 className="font-semibold text-gray-900 mb-3">Seguridad</h3>
        <Link to="/change-password" className="inline-block text-sm font-medium hover:underline" style={{ color: '#FFB800' }}>
          Cambiar contraseña
        </Link>
      </div>

      <div className="bg-white rounded-xl p-6 shadow-sm">
        <h3 className="font-semibold text-gray-900 mb-3">Verificación en dos pasos (2FA)</h3>
        {user?.totpEnabled ? (
          <div>
            <span className="inline-block text-xs px-2 py-1 rounded-full bg-green-100 text-green-700 mb-3">2FA activo</span>
            <div>
              <button onClick={handleDisable2FA} className="text-sm text-red-500 hover:underline">
                Desactivar 2FA
              </button>
            </div>
          </div>
        ) : (
          <div>
            <p className="text-sm text-gray-500 mb-3">
              Añade una capa extra de seguridad a tu cuenta.
              {user?.totpRequired && <span className="text-red-500 ml-1">(Obligatorio para tu cuenta)</span>}
            </p>
            <Link to="/setup-2fa" className="btn-accent inline-block text-sm px-4 py-2 rounded-lg transition-colors">
              Configurar 2FA
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
